import React from 'react';
import { styled } from '@components-shared/src/stitches';
import { TimeSlotSelector } from '@components/Waveform/TimeSlotSelector';

type SelectSlotProps = {
  containerRef: React.RefObject<HTMLDivElement>;
  canvasRef: React.RefObject<HTMLCanvasElement>;
  height: number;
  width: number;
  claimedSlots: Set<number>;
  totalSlots: number;
  onSelectorClick: (event: React.MouseEvent<HTMLCanvasElement, MouseEvent>) => void;
  setDefaultX: () => void;
  handleMouseMove: (event: React.MouseEvent<HTMLCanvasElement, MouseEvent>) => void;
};

export function SelectSlot({
  containerRef,
  canvasRef,
  height,
  width,
  claimedSlots,
  totalSlots,
  setDefaultX,
  handleMouseMove,
  onSelectorClick,
}: SelectSlotProps) {
  return (
    <TimeSlotContainer ref={containerRef}>
      <TimeSlotSelector
        canvasRef={canvasRef}
        height={height}
        width={width}
        claimedSlots={claimedSlots}
        totalSlots={totalSlots}
        setDefaultX={setDefaultX}
        handleMouseMove={handleMouseMove}
        onSelectorClick={onSelectorClick}
      />
    </TimeSlotContainer>
  );
}

const TimeSlotContainer = styled('div', {
  backgroundColor: '$neutral50',
  borderRadius: '8px',
  display: 'flex',
  alignItems: 'center',
  height: '132px',
  overflow: 'hidden',
  '@tablet': {
    height: '112px',
  },
});
